import { checkForSatelliteAndInitialize } from '@nmx/utils/dist/utilities/frontend/Analytics/dtm_helper';
import registerComponent from './register_component';

// Import global analytics

import { navScript } from './helpers/nav.header';

// Grab UTM codes from the url and store them in the session so they can be utilized later for tracking purposes
import './session/utm';

// TODO: so much of this is junk. Will start with markup/styles first, then will come back to address JS/React
import NMXSearch from './components/nmx-search.component';
import NMUserLogin from './components/nm_user_login.component';
import NMLoginButton from './components/nm_login_button.component';
import NMExpandableToast from '../../components/modules/ExpandableToast';
import InformationalBanner from '../../components/modules/InformationalBanner';
import StickyBanner from '../../components/modules/StickyBanner';

navScript();
checkForSatelliteAndInitialize(1000, 10);

const preClientId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
  /[018]/g,
  c => (
    c
      ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
  ).toString(16),
);
sessionStorage.setItem('pre-client-id', preClientId);
window.adobeDataLayer = window.adobeDataLayer || [];
window.adobeDataLayer.push({
  'user-details': {
    ids: {
      'pre-client-id': preClientId,
    },
  },
});
XMLHttpRequest.prototype.open = (function (open) {
  return function (method, url, async) {
    open.apply(this, arguments);
    if (url.indexOf('/nmx-api-proxy/nmx/') > 0) {
      this.setRequestHeader('X-Pre-Client-Id', preClientId);
    }
  };
}(XMLHttpRequest.prototype.open));

registerComponent('nmx-search', NMXSearch, true);
registerComponent('nm-user-login', NMUserLogin);
registerComponent('nm-login-button', NMLoginButton);
registerComponent('nm-expandable-toast', NMExpandableToast);
registerComponent('nm-informational-banner', InformationalBanner, true);
registerComponent('nm-sticky-banner', StickyBanner, true);
